import { render, staticRenderFns } from "./CaregiverBehaviorTable.vue?vue&type=template&id=0d0ac6e4&scoped=true"
import script from "./CaregiverBehaviorTable.vue?vue&type=script&lang=js"
export * from "./CaregiverBehaviorTable.vue?vue&type=script&lang=js"
import style0 from "./CaregiverBehaviorTable.vue?vue&type=style&index=0&id=0d0ac6e4&prod&lang=scss"
import style1 from "./CaregiverBehaviorTable.vue?vue&type=style&index=1&id=0d0ac6e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0ac6e4",
  null
  
)

export default component.exports